export default "__VITE_ASSET__B6S9rvMM__";